import { Trans, useLingui } from "@lingui/react/macro";

import LogoIcon from "@/assets/icons/logo.svg?react";
import aboutInfo from "@/assets/images/about-elsafwa.png";

import InformativeText from "../informative-text";
import { Benefits } from "../list-property-section";

const InfoSection = () => {
  const { t } = useLingui();

  return (
    <section className="flex flex-col gap-10 rounded-4xl bg-(--color-bg-color-bg-dark-beige) px-4 py-6 text-(--color-text-color-text-grey) lg:flex-row lg:rounded-4xl lg:p-8">
      <div className="relative order-2 lg:order-1 lg:w-[650px]">
        <img
          src={aboutInfo}
          alt="about us info"
          loading="lazy"
          className="rounded-5xl size-full"
          width="460"
          height="576"
        />
        <LogoIcon className="absolute end-4 -top-10 lg:-end-10 lg:top-30" />
      </div>
      <div className="order-1 flex w-full flex-col lg:order-2">
        <div className="hidden lg:flex lg:flex-col xl:mb-18">
          <div className="flex flex-1 flex-col items-start self-end ps-12 lg:w-full xl:w-3/4">
            <div className="flex gap-2 lg:mb-6 xl:mb-11">
              <InformativeText text={t`luxury Resorts`} />
              <InformativeText text={t`Residential Complexes`} />
            </div>
            <div className="flex flex-col gap-6 lg:order-2">
              <p className="text-base leading-6 font-normal">
                <Trans>
                  A Deep commitment to making people feel at home. We’re still family-run, proudly
                  independent, and focused on one thing: creating places where people don’t just
                  stay—they belong.
                </Trans>
              </p>
              <Benefits />
            </div>
          </div>
        </div>
        <div className="order-1 mb-4 flex flex-wrap gap-2 lg:hidden">
          <InformativeText text={t`luxury Resorts`} />
          <InformativeText text={t`Residential Complexes`} />
        </div>
        <div className="order-3 flex w-full flex-col gap-6 lg:hidden">
          <p className="text-base leading-6 font-normal">
            <Trans>
              El Safwa specializes in developing residential and mixed-use properties, focusing on
              vibrant communities and enhancing quality of life. Its projects include luxury
              resorts, residential complexes, commercial hubs, and recreational spaces, all built to
              top standards.
            </Trans>
          </p>
          <Benefits />
        </div>
        <div className="order-2 mb-4 flex flex-col gap-4 lg:order-3 lg:mb-6 xl:mb-10 xl:w-4/5">
          <div className="flex flex-wrap gap-2 lg:mb-2 xl:mb-4">
            <InformativeText text={t`Touristic Development`} />
            <InformativeText text={t`Modern Amenities`} />
          </div>
          <h1 className="text-3xl leading-10 font-normal lg:leading-16 xl:text-5xl">
            <Trans>About</Trans>{" "}
            <span className="font-semibold">
              <Trans>El Safwa</Trans>
            </span>
          </h1>
          <p className="text-base leading-6 font-normal">
            <Trans>
              El Safwa is more than a name — it’s a story of vision, resilience, and purpose. It
              began as an architecture firm, designing and building standout residential spaces in
              Maadi and Masr El Gedeeda, and the family quickly earned a reputation for quality and
              innovation.
            </Trans>
          </p>
        </div>
      </div>
    </section>
  );
};

export default InfoSection;
